import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import classnames from "classnames";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { Icon } from "../Icon/index.js";
import { TreeItem } from "./TreeItem.js";
import { useStyles } from "./TreeView.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const parseParents = (items, parents = [])=>{
    let result = {};
    items.forEach((item)=>{
        result[item.id] = parents;
        if (item.children && item.children.length) result = _object_spread({}, result, parseParents(item.children, [
            ...parents,
            item.id
        ]));
    });
    return result;
};
const TreeView = (props)=>{
    const $ = c(39);
    const { onSelect, onChildrenLoad, items, selectOnShrink: t0, showRulers: t1, showCounters: t2, withPaddingBottom: t3, renderOption } = props;
    const selectOnShrink = void 0 === t0 ? true : t0;
    const showRulers = void 0 === t1 ? true : t1;
    const showCounters = void 0 === t2 ? true : t2;
    const withPaddingBottom = void 0 === t3 ? false : t3;
    let t4;
    if ($[0] !== withPaddingBottom) {
        t4 = {
            withPaddingBottom
        };
        $[0] = withPaddingBottom;
        $[1] = t4;
    } else t4 = $[1];
    const { classes } = useStyles(t4);
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[2] = t5;
    } else t5 = $[2];
    const [expanded, expand] = useState(t5);
    let t6;
    if ($[3] !== items || $[4] !== props.selected) {
        t6 = props.selected && parseParents(items)[props.selected] || [];
        $[3] = items;
        $[4] = props.selected;
        $[5] = t6;
    } else t6 = $[5];
    const parentsOfSelected = t6;
    let t7;
    let t8;
    if ($[6] !== items || $[7] !== props.selected) {
        t7 = ()=>{
            expand((previous)=>[
                    ...previous,
                    ...parseParents(items)[props.selected] || []
                ]);
        };
        t8 = [
            props.selected,
            items
        ];
        $[6] = items;
        $[7] = props.selected;
        $[8] = t7;
        $[9] = t8;
    } else {
        t7 = $[8];
        t8 = $[9];
    }
    useEffect(t7, t8);
    const customBulletIcon = _temp;
    const customExpandMoreIcon = _temp2;
    const customExpandLessIcon = _temp3;
    let t9;
    if ($[10] !== classes.root) {
        t9 = classnames(classes.root, "aqa_tree_view");
        $[10] = classes.root;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {
            collapseIcon: customExpandLessIcon,
            endIcon: customBulletIcon,
            expandIcon: customExpandMoreIcon
        };
        $[12] = t10;
    } else t10 = $[12];
    const t11 = props.selected;
    let t12;
    if ($[13] !== expanded || $[14] !== items || $[15] !== onChildrenLoad || $[16] !== onSelect || $[17] !== parentsOfSelected || $[18] !== props.selected || $[19] !== renderOption || $[20] !== selectOnShrink || $[21] !== showCounters || $[22] !== showRulers) {
        let t13;
        if ($[24] !== expanded || $[25] !== onChildrenLoad || $[26] !== onSelect || $[27] !== parentsOfSelected || $[28] !== props.selected || $[29] !== renderOption || $[30] !== selectOnShrink || $[31] !== showCounters || $[32] !== showRulers) {
            t13 = (item)=>/*#__PURE__*/ jsx(TreeItem, {
                    item: item,
                    showRulers: showRulers,
                    showCounters: showCounters,
                    onSelect: onSelect,
                    expanded: expanded,
                    onExpand: (value)=>expand((previous_0)=>{
                            if (previous_0.includes(value)) {
                                if (selectOnShrink && parentsOfSelected.includes(value)) onSelect(value);
                                return previous_0.filter((previousExpanded)=>previousExpanded !== value);
                            }
                            return [
                                ...previous_0,
                                value
                            ];
                        }),
                    onChildrenLoad: onChildrenLoad,
                    selected: props.selected,
                    renderOption: renderOption
                }, item.id);
            $[24] = expanded;
            $[25] = onChildrenLoad;
            $[26] = onSelect;
            $[27] = parentsOfSelected;
            $[28] = props.selected;
            $[29] = renderOption;
            $[30] = selectOnShrink;
            $[31] = showCounters;
            $[32] = showRulers;
            $[33] = t13;
        } else t13 = $[33];
        t12 = items.map(t13);
        $[13] = expanded;
        $[14] = items;
        $[15] = onChildrenLoad;
        $[16] = onSelect;
        $[17] = parentsOfSelected;
        $[18] = props.selected;
        $[19] = renderOption;
        $[20] = selectOnShrink;
        $[21] = showCounters;
        $[22] = showRulers;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[34] !== expanded || $[35] !== props.selected || $[36] !== t12 || $[37] !== t9) {
        t13 = /*#__PURE__*/ jsx(SimpleTreeView, {
            expandedItems: expanded,
            className: t9,
            slots: t10,
            "data-testid": "tree-view-root-test-id",
            selectedItems: t11,
            children: t12
        });
        $[34] = expanded;
        $[35] = props.selected;
        $[36] = t12;
        $[37] = t9;
        $[38] = t13;
    } else t13 = $[38];
    return t13;
};
function _temp() {
    return /*#__PURE__*/ jsx(Icon, {
        name: "circle_small_filled",
        size: "20",
        color: "text.light.tertirary"
    });
}
function _temp2() {
    return /*#__PURE__*/ jsx(Icon, {
        name: "dropdown_outline",
        size: "16",
        color: "text.light.tertirary"
    });
}
function _temp3() {
    return /*#__PURE__*/ jsx(Icon, {
        name: "dropdown_flipped_outline",
        size: "16",
        color: "text.light.tertirary"
    });
}
export { TreeView };
